module.exports = __webpack_public_path__ + "static/media/catalouge-28.5680d62b.jpg";